import { galleryReload } from './main-product-gallery';
import { showLoader, hideLoader, conditionalContentSet, conditionalImgSet } from '../utils/utils';
import { on } from 'delegated-events';
import { updateWidth } from '../scroll-to-element';


function trimDecimal(value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const n = Number(value);
    return isNaN(n) ? '' : n.toString();
}

export default function () {
    function priceFormatterNew(value) {
        if (value == null) return value;

        return new Intl.NumberFormat('pl-PL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    function priceFormatter(value) {

        if (value)
            return value.toFixed(2).toString().replace('.', ',');
        return value;
    }


    on('click', '[select-option]', function (event) {

        gatherAndSend(this, this.getAttribute("select-option"));
    });

    function gatherAndSend(caller, optionId) {

        showLoader();


        const scope = caller.closest('[data-scope="addcart"]');
        //const selectedFeatureArray = [];
        //scope.querySelectorAll('dd ul').forEach(ul => {
        //    ul.querySelectorAll('li').forEach(li => {
        //        if (li.classList.contains('selected')) {
        //            selectedFeatureArray.push(li.getAttribute('data-dictid'));
        //        }
        //    });
        //});

        fetch('/cartaction/FetchOptions', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                request: {

                    optionId: +optionId,
                    pid: scope.querySelector('[data-pid]').getAttribute('data-pid')
                }
            }),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.json())
            .then(data => {

                console.log(data);

                // Wariant zniknął z bazy (panel/ERP), a strona w przeglądarce jest nieaktualna —
                // przeładowanie daje użytkownikowi aktualną listę wariantów zamiast martwego klika.
                if (data && data.OptionMissing) {
                    if (data.ProductUrl) {
                        window.location.href = data.ProductUrl;
                    } else {
                        window.location.reload();
                    }
                    return;
                }

                const optionItem = scope.querySelector('[data-optionid]');


                optionItem.setAttribute('data-optionid', data.OptionId);


                if (data.ProductVariantUrl) {
                    window.history.pushState(null, null, data.ProductVariantUrl);
                }

                if (data.HtmlResponse) {
                    scope.querySelector('[data-role="option-view"]').innerHTML = data.HtmlResponse;
                    window.lazyLoadInstance.update();
                }

                conditionalContentSet(document, '[data-role="sku"]', data.SKU);
                conditionalContentSet(document, '[data-role="ean"]', data.EAN);
                conditionalContentSet(document, '[data-role="installments"]', data.Installment);
                
    
                if (data.LeadVisuals) {
                    conditionalContentSet(document, '[data-role="color-name"]', data.LeadVisuals.DictionaryName);
                    conditionalContentSet(document, '[data-role="color-description"]', data.LeadVisuals.Description);
                    conditionalImgSet(document, '[data-img]', data.LeadVisuals.ImageUrl);
                }
                if (data.Prices) {
                    var pricesItem = data.Prices;
                   
                    conditionalContentSet(scope, '[data-role="product-price"]', trimDecimal(pricesItem.PriceGross));
                    conditionalContentSet(document, '[data-role="product-price-floating"]', trimDecimal(pricesItem.PriceGross));

                   

                    const omnibusPrice = scope.querySelector('[data-role="omnibus-lowest-price"]');
                    if (omnibusPrice) {
                        omnibusPrice.innerHTML = '';

                        if (pricesItem.OldPriceGross) {
                            omnibusPrice.innerHTML = pricesItem.OmnibusInfo;
                        }
                    }

                    conditionalContentSet(scope, '[data-role="product-discount-percentage"]', pricesItem.PercentDiscount);
                    conditionalContentSet(scope, '.promo-text', pricesItem.PercentDiscount);
                    conditionalContentSet(scope, '[data-role="product-oldprice"]', trimDecimal(pricesItem.OldPriceGross));
                }

                if (data.ProductState) {
                    const state = data.ProductState;
                    const availName = scope.querySelector('[data-role="avail-name"]');

                    if (availName) {
                        availName.innerHTML = state.Name;
                        availName.style.color = state.HexHtmlColor;
                    }

                    conditionalContentSet(document, '[data-role="avail-desc"]', state.Description);
                    conditionalContentSet(document, '[data-role="avail-time"]', state.ShippingTime);
                }

                if (data.Images) {
                    galleryReload(data.Images);
                }

                if (typeof exponea !== 'undefined' && data.ExponeaViewItem) {
                    exponea.track('view_item', JSON.parse(data.ExponeaViewItem));
                }

                updateWidth();

                const buyButton = scope.querySelector('.buy-button');

                if (data.CartEnabled) {
                    scope.classList.remove('cart-disabled');
                    buyButton.removeAttribute('disabled');
                } else {
                    scope.classList.add('cart-disabled');
                    buyButton.setAttribute('disabled', true);
                }



                hideLoader();
            })
            .catch(error => {
                console.log(error);
                hideLoader();
            });
    }

}